<script>
import 'vue-croppa/dist/vue-croppa.css';
import '@helper/Gen.js';

import env from '@root/env';

export default {
	props: {
		name: String,
		type: String,
		value: [Array,String],
		uploadType: {default: ""},
    attr:{default:()=>({})},
		param: {default:()=>({thumbnail:false})},
		galleryParams: {default:()=>({})},
		noHelp: {default: false},
		required: Boolean,
	},
	data: function () {
		return {
			uploading: false,
			error: false,
			uploadText: this.uploadType == "gallery" ? "Select" : "Upload"
		}
	},
  computed:{
    page(){ return this.$root.page },
    fields(){ return this.$root.fields },
    path(){ return this.$root.app.path },
    uploader(){ return this.$root.app.uploader },
		conf(){ return this.$root.app.uploader[this.type] },
		bindAttr(){
			if(!this.page) return {}
			if(!this.page.validation) return {}
      var attr = Gen.clone(this.attr)
      attr.placeholder = attr.placeholder || this.fields[this.name]
      return Object.assign(this.page.validation(this.name),attr)
		}
  },
	mounted: function () {
		this.init()
	},
	methods: {
		init(){
			global.Uploader = this
			if(!this.conf) return
			this.elFile = $(this.$el).find('[type="file"]')
			this.param.type = this.type
			if (!this.uploadType){
				this.param.uploadType = this.conf.img_ratio ? "cropping" : "upload"
			}else{
				this.param.uploadType = Gen.clone(this.uploadType)
			}
			if (this.value) this.uploadText = "Update"
		},
		uploadClick(){
			if(this.uploadType=='gallery') this.openGallery()
		},
		openGallery(){
			global.FileManager.open((files)=>{
				if(files.length){
					var arrayValue = [];
					files.forEach((v)=>{
						arrayValue.push(v.pathfile)
					})
					this.$emit('input', arrayValue)
				}else{
					this.$emit('input', files.pathfile);
				}
				this.$emit('response', this)
				this.valid()
			}, Object.assign({type:this.type}, this.galleryParams))
		},
		onUpload: function (e) {
			this.fileData = this.elFile.prop('files')[0];
			this.conf.fileType = this.fileData.type;
			this.fileType = this.fileData.name.substr(this.fileData.name.lastIndexOf('.') + 1).toLowerCase();
			if (this.conf.rule_size){
				var reader = new FileReader();
				reader.onload = () => {
					var img = new Image;
					img.onload = () => {
						this.img = img
						this.uploadProcess(e)
					}
					img.src = reader.result
				};
				reader.readAsDataURL(this.fileData);
			}else{
				this.uploadProcess(e)
			}
		},
		uploadProcess: function(e){
			// Validation
			this.error = false;
			if (this.conf['rule_type'].indexOf(this.fileType) == -1) {
				this.error = 'File type must be ' + this.conf['rule_type'] + ' type.';
			}
			if (this.fileData.size > this.uploader['max_image_size']) {
				this.error = 'Max file size is 5MB';
			}
			if (this.conf.rule_size) if(this.img.naturalWidth<this.conf.rule_size[0]||this.img.naturalHeight<this.conf.rule_size[1]){
				this.error = 'Minimum image size is '+this.conf.rule_size[0]+"x"+this.conf.rule_size[1]
			}
			if (this.error) return alert(this.error);
			var formData = new FormData();
			formData.append(this.type=="editor" ? 'upload' : 'file', this.fileData);
			this.param.pageType = this.type;
			$.each(this.param, (k, v) => {
				formData.append(k, v);
			});

			$.ajax({
				url: env.baseUrl + "/api/public/ajax/upload",
				type: "POST",
				data: formData,
				enctype: 'multipart/form-data',
				processData: false, // tell jQuery not to process the data
				contentType: false // tell jQuery not to set contentType
			}).done((resp) => {
				this.uploadText = "Update";
				if (this.param.uploadType == "upload") {
					this.$emit('input', resp.filename);
					this.$emit('response', this)
					this.valid()
					return;
				}
				return ImageFilter.open(resp.targetfile, (data) => {
					var form_data = new FormData();
					form_data.append("file", data);
					form_data.append("path", this.type);
					form_data.append("image_name", resp.filename);
					$.ajax({
						url: env.baseUrl + "/api/public/ajax/upload_filter",
						type: "POST",
						data: form_data,
						enctype: 'multipart/form-data',
						processData: false,  // tell jQuery not to process the data
						contentType: false,
						success: (resp) => {
							this.$emit('input', resp.filename);
							this.$emit('response', this);
							this.valid()
						}
					});
				}, this.conf);
			});
		},
		valid(){
			setTimeout(()=>{
				if(!$(this.$el).find(".image-preview input").length) return;
				$(this.$el).find(".image-preview input").valid()
			}, 100)
		},
		deleteVal(k){
			var val = Gen.clone(this.value)
			val.splice(k,1)
			this.$emit("input", val)
		}
	},
	watch:{
		type(){
			setTimeout(()=>{ this.init() },300)
		}
	}
}
</script>

<template>
  <div class="upload-container" v-if="conf">
    <slot name="preview">
      <div class="image-preview">
      	<div v-if="!param.thumbnail">
      		<template v-if="typeof value == 'object'">
      			<template v-for="(v,k) in value">
      				<div class="box_multiple">
						<ImagePreview :src="page.uploader(v)" v-if="v"></ImagePreview>
						<span @click="deleteVal(k)" class="close_multiple"><i class="ti-close"></i> &nbsp;&nbsp;</span>
					</div>
      			</template>
		        <input type="hidden" :name="name" value="value[0]" v-bind="bindAttr">
      		</template>
      		<template v-else>
				<ImagePreview :src="page.uploader(value)" v-if="value"></ImagePreview>
		        <input type="hidden" :name="name" :value="value" v-bind="bindAttr">
      		</template>
      	</div>
      	<div v-else>
      		<VImg class="image_thumb" v-for="(v,k) in value" :key="k" :src="uploader(v)"></VImg>
      	</div>
      </div>
    </slot>
    <a href="javascript:;" class="btn btn-info upload-btn" @click="uploadClick">
      <span class="upload-label">
        <slot v-if="!uploading" name="label" :uploadText="uploadText"><i class="ti-file"></i> {{uploadText}} Photo</slot>
        <span v-if="uploading">Uploading...</span>
      </span>
      <input v-if="uploadType!='gallery'" type="file" @change="onUpload" :id="name">
    </a>
    <span class="help-block">
      <small>Accepted formats : {{conf.rule_type}}. Max file size {{uploader["max_image_size"].bytesToSize()}}</small>
    </span>
  </div>
</template>

